import { Link } from "react-router-dom";

const Opportunity = () => {
  return (
    <section className="section job-register" id="register">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="register-job-blk">
              <div className="job-content-blk aos" data-aos="fade-up">
                <h1>Find Your Next Great Job Opportunity!</h1>
                <p>
                  Stop settling and start thriving. Browse top-tier listings and find the perfect role that matches your skills and ambitions today.
                </p>
              </div>
              <div className="see-all mt-0 aos" data-aos="fade-up">
                <Link to="/register" className="btn all-btn">
                  Register Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Opportunity;
